import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import { P2pSharePolicyComponent } from './p2p-share-policy.component';

@Injectable()
export class P2pSharePolicyDialog {
  readonly #dialog = inject(DialogService);

  open(): DialogRef {
    return this.#dialog.open(P2pSharePolicyComponent);
  }
}
